import React, { useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Section } from "../utils/Entities";
import { Button, ButtonVariant } from "@merge-api/merge-javascript-shared";
import IntegrationBuilderContext from "../context/IntegrationBuilderContext";
import IntegrationBuilderLeftNavBarTab from "./components/IntegrationBuilderLeftNavBarTab";
import { getRelativePath } from "../utils/helpers";
import { ArrowLeft } from "lucide-react";
import { navigateToIntegration } from "../../../router/RouterUtils";
import { Text, Divider } from "@merge-api/merge-javascript-shared";

interface NavigationBarProps {
  sections: Section[];
  onNavigate: (path: string) => void;
  integrationID: string | undefined;
}

const IntegrationBuilderLeftNavBar = ({
  sections,
  onNavigate,
  integrationID,
}: NavigationBarProps) => {
  // hooks
  const history = useHistory();
  const { integration } = useContext(IntegrationBuilderContext);

  // state
  const [relativePathOfSelectedPage, setRelativePathOfSelectedPage] = React.useState("");

  // sets the active path on mount
  // partialPath uses the 4th item in path (ie.: admin.merge.dev/integration-builder/xyz/merge-link-steps --> merge-link-steps)
  useEffect(() => {
    setRelativePathOfSelectedPage(getRelativePath(history.location.pathname));
  }, [history.location.pathname]);

  return (
    <div className="max-w-[308px] min-w-[308px] border-r border-gray-10 bg-white">
      <div className="flex flex-col p-5 gap-y-4">
        {integrationID && (
          <Button
            leftIcon={<ArrowLeft size={16} />}
            size="md"
            variant={ButtonVariant.TextBlue}
            onClick={() => {
              navigateToIntegration(history, integrationID);
            }}
          >
            Back to {integration?.name}
          </Button>
        )}
        <Text variant="h3">
          {integrationID
            ? "Building " + integration?.name
            : "Welcome to the guided Integration Builder!"}
        </Text>
        <Divider />
      </div>
      <div className="flex flex-col gap-y-2 px-2">
        {sections.map((item, itemIndex) => {
          return (
            <IntegrationBuilderLeftNavBarTab
              key={itemIndex}
              item={item}
              itemIndex={itemIndex}
              relativePathOfSelectedPage={relativePathOfSelectedPage}
              onNavigate={onNavigate}
            />
          );
        })}
      </div>
    </div>
  );
};

export default IntegrationBuilderLeftNavBar;
